var _g, _path, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileRightBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_186_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0V24.5063L18.3631 26.1407H0V1.62704L1.64555 0H20Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.975 0.025V24.4959L18.3528 26.1157H0.025V1.63748L1.65582 0.025H19.975Z",
    stroke: "url(#paint0_linear_186_18)",
    strokeOpacity: 0.5,
    strokeWidth: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.975 0.025V24.4959L18.3528 26.1157H0.025V1.63748L1.65582 0.025H19.975Z",
    stroke: "url(#paint1_linear_186_18)",
    strokeOpacity: 0.5,
    strokeWidth: 0.05
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_186_18",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0V24.5063L18.3632 26.1407H3.05176e-05V1.62704L1.64558 0H20Z",
    fill: "white",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.975 0.025V24.4959L18.3528 26.1157H0.0250305V1.63748L1.65585 0.025H19.975Z",
    stroke: "url(#paint2_linear_186_18)",
    strokeOpacity: 0.5,
    strokeWidth: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.975 0.025V24.4959L18.3528 26.1157H0.0250305V1.63748L1.65585 0.025H19.975Z",
    stroke: "url(#paint3_linear_186_18)",
    strokeOpacity: 0.5,
    strokeWidth: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_186_18)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_186_18)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.1322,
    cy: 22.1322,
    r: 22.1322,
    transform: "matrix(-1 0 0 1 46.0554 4.00781)",
    fill: "#0E9BDF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_186_18",
    x: -15,
    y: -15,
    width: 50,
    height: 56.1406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_186_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_186_18",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_186_18",
    x: -10.2089,
    y: -7.99219,
    width: 68.2643,
    height: 68.2637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_186_18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_18",
    x1: 5.68969,
    y1: -2.22803,
    x2: 16.6921,
    y2: 1.34861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_186_18",
    x1: 21.038,
    y1: 22.8316,
    x2: 15.6632,
    y2: 21.5137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_186_18",
    x1: 5.68972,
    y1: -2.22803,
    x2: 16.6922,
    y2: 1.34861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_186_18",
    x1: 21.038,
    y1: 22.8316,
    x2: 15.6633,
    y2: 21.5137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRightBackground);
export default __webpack_public_path__ + "static/media/profile_right_background.ee314ac3a88e9dee1ab23661b7c06db2.svg";
export { ForwardRef as ReactComponent };